// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { SimulationCaptureReplay, SimulationCaptureReplayT } from "./simulation-capture-replay";
import { SimulationOpcUaScript, SimulationOpcUaScriptT } from "./simulation-opc-ua-script";

/**
 * Where a scenario bank's vendor traffic comes from.
 */
export enum SimulationBankSource {
  NONE = 0,
  SimulationCaptureReplay = 1,
  SimulationOpcUaScript = 2,
}

export function unionToSimulationBankSource(
  type: SimulationBankSource,
  accessor: (
    obj: SimulationCaptureReplay | SimulationOpcUaScript,
  ) => SimulationCaptureReplay | SimulationOpcUaScript | null,
): SimulationCaptureReplay | SimulationOpcUaScript | null {
  switch (SimulationBankSource[type]) {
    case "NONE":
      return null;
    case "SimulationCaptureReplay":
      return accessor(new SimulationCaptureReplay())! as SimulationCaptureReplay;
    case "SimulationOpcUaScript":
      return accessor(new SimulationOpcUaScript())! as SimulationOpcUaScript;
    default:
      return null;
  }
}

export function unionListToSimulationBankSource(
  type: SimulationBankSource,
  accessor: (
    index: number,
    obj: SimulationCaptureReplay | SimulationOpcUaScript,
  ) => SimulationCaptureReplay | SimulationOpcUaScript | null,
  index: number,
): SimulationCaptureReplay | SimulationOpcUaScript | null {
  switch (SimulationBankSource[type]) {
    case "NONE":
      return null;
    case "SimulationCaptureReplay":
      return accessor(index, new SimulationCaptureReplay())! as SimulationCaptureReplay;
    case "SimulationOpcUaScript":
      return accessor(index, new SimulationOpcUaScript())! as SimulationOpcUaScript;
    default:
      return null;
  }
}

export type SimulationBankSourceT =
  | { type: "NONE"; value: null }
  | { type: "SimulationCaptureReplay"; value: SimulationCaptureReplayT }
  | { type: "SimulationOpcUaScript"; value: SimulationOpcUaScriptT };
